import {initialState} from "./initialState";
//this function will be executed after calling dispatch(action). Additional property will be added to handle different use case. such as action.field, action.keyword etc.
export const reducer = (state, action) =>{
	//Each time user change the searching param, the stage will be updated to "REQUEST_RECORDS" and request data from backend.
	switch(action.type){
		case "handleSort":
		{
			let field = action.field;
			var value = state.sort[field] && (state.sort[field] === 'descending') ? 'ascending' :'descending' ; //If ascending, descending. If descending, ascending.
			return{...state , ...{stage:"REQUEST_RECORDS",offset:"0",requestCount:"true",sort:{...{[field]:value},...state.sort,...{[field]:value}}}}
		}
		case "handleSearch":
		{
			const keyword = action.keyword;
			const sort = Object.keys(state.sort).length === 0? {"Create Time": "descending"} : state.sort; //If keyword is provided. Don't sort the result and show the most relevence data at top. Else, show the latest data at top.
			return{...state , ...{stage:"REQUEST_RECORDS",offset:"0",requestCount:"true",sort:sort,keyword:keyword}} //offset is changed to 0 to display first page.
		}
		case "handlePaginationNum":
		{
			const offset = action.offset;
			return{...state , ...{stage:"REQUEST_RECORDS",offset : offset,requestCount:""}}; //No need to count number of datas because only pagination number is changed.
		}
    case "reset":
		{
			return{...initialState};
		}
		case "labels":
		case "prints":
		case "scans":
		case "unlocks":
		case "matches":
		case "clear":	
		case "unclear":
		case "mismatch":
			return {...initialState,...{dataType:action.type}} //If data type is changed, update the dataType and use initial setting for other properties.
		case "updateRecords":
		{
			const datas = action.datas;
			const count = action.count;
			const dataType = action.dataType;
			var update= {
				stage:"DISPLAY_RECORDS",
				rows:datas, //new datas requested from backend
				count:count ? count : state.count, //total number of datas. If not provide, old count will be used.
				dataType:dataType ? dataType : state.dataType //new dataType. If not provide, old dataType will be used.
			};
			return{...state , ...update};

		}
		default:
			return false;
	}
}
